const Resume = () => {
  return (
    <div className='cta'>
        <a 
          target="_blank"
          href='https://drive.google.com/file/d/17gjIg8kJLmMxYbVlV7q5bvL2Df9KlXXd/view?usp=sharing'
          download
          className='btn'
          rel="noopener noreferrer"
        >
          Descargar HV
        </a>
        <a href='#contact' className='btn btn-primary'>Hablemos de HV</a>
    </div>
  )
}

export default Resume